import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(0, 0, 0, 0.55)' : 'rgba(15, 23, 42, 0.4)'};
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  z-index: 1000;
`

export const ModalContainer = styled.div`
  width: min(100%, 28rem);
  padding: 1.5rem 1.5rem 1.25rem;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) =>
    theme.name === 'dark' ? theme.colors.backgroundSecondary : '#fff'};
  color: ${({ theme }) => theme.colors.textPrimary};
  box-shadow:
    0 18px 40px rgba(15, 23, 42, 0.18),
    0 2px 8px rgba(15, 23, 42, 0.08);
`

export const ModalHeader = styled.h2`
  margin: 0 0 0.65rem;
  font-size: 1.125rem;
  font-weight: 650;
  letter-spacing: -0.01em;
  line-height: 1.3;
`

export const ModalBody = styled.p`
  margin: 0 0 1.35rem;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem;
`
